import Vue from 'vue'
//import ElementUI from 'element-ui'

import App from './App.vue'
import router from '@/router'
import store from '@/store'
import './assets/css/icon.css'
import VueCookies from 'vue-cookies'
//引入nprogress
import NProgress from "nprogress";
import "nprogress/nprogress.css"; //这个样式必须引入
import {
  Button,
  Carousel,
  Input,
  CarouselItem,
  Form,
  FormItem,
  Message
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.prototype.$message = Message;
Vue.use(Button)
  .use(Carousel)
  .use(Input)
  .use(CarouselItem)
  .use(Form)
  .use(FormItem)



// 简单配置
NProgress.inc(0.2);
NProgress.configure({ easing: "ease", speed: 500, showSpinner: false });
Vue.config.productionTip = false

Vue.use(VueCookies);

router.beforeEach((to, from, next) => {
  NProgress.start();
  document.title = `${to.meta.title}`;
  const role = sessionStorage.getItem("ms_username");

  if (!role && to.path !== "/login") {
    //next("/login");
  } else {
  }
  next()
})


router.afterEach(() => {
  NProgress.done();
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


